export const UPDATE_WALLET = 'UPDATE_WALLET'
export const UPDATE_MNEMONIC = 'UPDATE_MNEMONIC'
export const UPDATE_HISTORYURL = 'UPDATE_HISTORYURL'
export const UPDATE_BEFOREURL = 'UPDATE_BEFOREURL'
export const UPDATE_NEWWALLETURL = 'UPDATE_NEWWALLETURL'
export const UNLOCK_WALLET = 'UNLOCK_WALLET'
export const BALANCE = 'BALANCE'
export const OFFLINE = 'OFFLINE'
export const MODE = 'MODE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js